module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-align-to-left.8223f733a89b3be53a258970f169e223.svg";